// WhatsApp number in international format, digits only (e.g. "919876543210").
// The floating sigil stays hidden while this is empty.
export const WHATSAPP_NUMBER = "918971263589";
export const WHATSAPP_PREFILL =
  "Greetings, Prisca Arcana — I seek guidance. My matter concerns: ";
